/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Alloy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type InternalEventStatus = 'LaunchQueued' | 'CreatingView' | 'CreatingScenario' | 'CreatingWorkspace' | 'WritingWorkspaceFile' | 'PlanningLaunch' | 'PlannedLaunch' | 'ApplyingLaunch' | 'FailedLaunch' | 'AppliedLaunch' | 'StartingScenario' | 'Launched' | 'EndQueued' | 'DeletingView' | 'DeletedView' | 'DeletingScenario' | 'DeletedScenario' | 'DeletingWorkspace' | 'VerifyingWorkspace' | 'DeletedWorkspace' | 'PlanningDestroy' | 'PlannedDestroy' | 'ApplyingDestroy' | 'FailedDestroy' | 'AppliedDestroy' | 'Ended' | 'PlanningRedeploy' | 'PlannedRedeploy' | 'ApplyingRedeploy' | 'AppliedRedeploy';

export const InternalEventStatus = {
    LaunchQueued: 'LaunchQueued' as InternalEventStatus,
    CreatingView: 'CreatingView' as InternalEventStatus,
    CreatingScenario: 'CreatingScenario' as InternalEventStatus,
    CreatingWorkspace: 'CreatingWorkspace' as InternalEventStatus,
    WritingWorkspaceFile: 'WritingWorkspaceFile' as InternalEventStatus,
    PlanningLaunch: 'PlanningLaunch' as InternalEventStatus,
    PlannedLaunch: 'PlannedLaunch' as InternalEventStatus,
    ApplyingLaunch: 'ApplyingLaunch' as InternalEventStatus,
    FailedLaunch: 'FailedLaunch' as InternalEventStatus,
    AppliedLaunch: 'AppliedLaunch' as InternalEventStatus,
    StartingScenario: 'StartingScenario' as InternalEventStatus,
    Launched: 'Launched' as InternalEventStatus,
    EndQueued: 'EndQueued' as InternalEventStatus,
    DeletingView: 'DeletingView' as InternalEventStatus,
    DeletedView: 'DeletedView' as InternalEventStatus,
    DeletingScenario: 'DeletingScenario' as InternalEventStatus,
    DeletedScenario: 'DeletedScenario' as InternalEventStatus,
    DeletingWorkspace: 'DeletingWorkspace' as InternalEventStatus,
    VerifyingWorkspace: 'VerifyingWorkspace' as InternalEventStatus,
    DeletedWorkspace: 'DeletedWorkspace' as InternalEventStatus,
    PlanningDestroy: 'PlanningDestroy' as InternalEventStatus,
    PlannedDestroy: 'PlannedDestroy' as InternalEventStatus,
    ApplyingDestroy: 'ApplyingDestroy' as InternalEventStatus,
    FailedDestroy: 'FailedDestroy' as InternalEventStatus,
    AppliedDestroy: 'AppliedDestroy' as InternalEventStatus,
    Ended: 'Ended' as InternalEventStatus,
    PlanningRedeploy: 'PlanningRedeploy' as InternalEventStatus,
    PlannedRedeploy: 'PlannedRedeploy' as InternalEventStatus,
    ApplyingRedeploy: 'ApplyingRedeploy' as InternalEventStatus,
    AppliedRedeploy: 'AppliedRedeploy' as InternalEventStatus
};

